<template>
  <div class="l-home">
    <div class="main-visual">
      <h1 id="home-title" class="main-visual__text"></h1>
    </div>
  </div>
</template>

<script>
import { init } from 'ityped';
export default {
  name: 'Home',
  data: function() {
    return {
      title: '神谷智次郎ポートフォリオ',
      description: ''
    };
  },
  methods: {
    itypedInit() {
      const myElm = document.querySelector('#home-title');
      const options = {
        loop: false,
        typeSpeed: 50,
        startDelay: 3000,
        showCursor: false,
        strings: ['TOMOJIRO KAMIYA']
      };
      init(myElm, options);
    }
  },
  created() {
    this.$store.commit('validHomePage');
  },
  mounted() {
    this.setMeta(this.title, this.description);
    this.itypedInit();
  },
  destroyed() {
    this.$store.commit('invalidHomePage');
  }
};
</script>

<style lang="scss" scoped>
.l-home {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.main-visual {
  position: absolute;
  left: 50%;
  top: 50%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background: url(../assets/tomojiro_kamiya.svg) no-repeat center center;
  background-size: contain;
  transform: translate(-50%, -50%);
  animation: blur 3s ease-in-out;

  @include mq-up() {
    width: 690px;
    height: 241px;
  }

  @include mq-down() {
    width: 100%;
    max-width: 90%;
    height: 130px;
  }
}
.main-visual__text {
  color: $white;
  font-weight: bold;
  letter-spacing: 0.1em;

  @include mq-up() {
    @include fz(32);
  }

  @include mq-down() {
    @include fz(20);
  }
}

@keyframes blur {
  0% {
    opacity: 0;
    filter: blur(10px);
  }
  100% {
    opacity: 1;
    filter: blur(0);
  }
}
</style>
